export const mimeTypes: Record<string, string> = {
	// fonts
	otf: 'font/otf',
	ttf: 'font/ttf',
	woff: 'font/woff',
	woff2: 'font/woff2',

	// images
	svg: 'image/svg+xml',
	png: 'image/png',
	jpg: 'image/jpeg',
	apng: 'image/apng',
	gif: 'image/gif',

	// data
	json: 'application/json',
	geojson: 'application/geo+json',
	csv: 'text/csv',
	zip: 'application/zip',
	bin: 'application/octet-stream',
	xml: 'application/xml',

	// code
	js: 'application/javascript',
	mjs: 'application/javascript',
	css: 'text/css',

	// documents
	html: 'text/html',
	pdf: 'application/pdf',
	doc: 'application/msword',
	docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	odt: 'application/vnd.oasis.opendocument.text',
	ppt: 'application/vnd.ms-powerpoint',
	pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
	odp: 'application/vnd.oasis.opendocument.presentation',
	xls: 'application/vnd.ms-excel',
	xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	ods: 'application/vnd.oasis.opendocument.spreadsheet',
}
